import { render, staticRenderFns } from "./editruletoordermerge.vue?vue&type=template&id=5ab9e0a6"
import script from "./editruletoordermerge.vue?vue&type=script&lang=js"
export * from "./editruletoordermerge.vue?vue&type=script&lang=js"
import style0 from "./editruletoordermerge.vue?vue&type=style&index=0&id=5ab9e0a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports